import { Component } from "@angular/core"

@Component({
	selector: "app-modal-loader",
	templateUrl: "./modal-loader.component.html",
	styleUrls: ["./modal-loader.component.scss"]
})
export class ModalLoaderComponent {}
